import { BotRecommendationRequest } from '@/models/BotRecommendationRequest';
import Category from '@/models/Category';
import { DialogFlowMessage } from '@/models/Chat';
import { GetCategoriesData } from '@/models/GetCategoriesData';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { LearningMap } from '../learningMap/types';
import { BotAction, ChatActionTypes, ChatbotOutput, ChatMessage } from './types';

export const sendChatMessage = (data: ChatMessage) => action(ChatActionTypes.COMPLETE_SEND_CHAT_MESSAGE_REQUEST, data);
export const completeChatSuccess = (data: DialogFlowMessage, replaceLastMessage?: Boolean) =>
    action(ChatActionTypes.COMPLETE_CHAT_SUCCESS, { data, replaceLastMessage });
export const completeChatFailure = (error: AxiosError) => action(ChatActionTypes.COMPLETE_CHAT_FAILURE, error);

export const bufferingMessage = () => action(ChatActionTypes.BUFFERING);

export const markChipAnswer = (messageIndex: number, options: number[]) => action(ChatActionTypes.MARK_CHIP_ANSWER, { index: messageIndex, options });

export const buildingLearningMap = (data: LearningMap) => action(ChatActionTypes.BUILDING_LEARNING_MAP, data);

export const buildingContentRecommendations = (botRecommendationRequest: BotRecommendationRequest) =>
    action(ChatActionTypes.BUILDING_CONTENT_RECOMMENDATIONS, botRecommendationRequest);
export const buildingContentRecommendationsClear = () => action(ChatActionTypes.BUILDING_CONTENT_RECOMMENDATIONS_CLEAR);

export const getBotRecommendationsRequest = (botRecommendationRequest: BotRecommendationRequest) =>
    action(ChatActionTypes.GET_RECOMMENDATION_REQUEST, botRecommendationRequest);
export const getBotRecommendationsFailure = () => action(ChatActionTypes.GET_RECOMMENDATION_FAILURE);

export const sendNewEventRequest = (eventName: string, putOnMessageList: boolean = false) =>
    action(ChatActionTypes.SEND_NEW_EVENT_REQUEST, { eventName, putOnMessageList });
export const sendNewEventSuccess = (chatbotOutput: ChatbotOutput) => action(ChatActionTypes.SEND_NEW_EVENT_SUCCESS, chatbotOutput);
export const sendNewEventFailure = () => action(ChatActionTypes.SEND_NEW_EVENT_FAILURE);

export const getChatCategoriesRequest = (getCategoriesData: GetCategoriesData) => action(ChatActionTypes.GET_CATEGORIES_REQUEST, getCategoriesData);
export const getChatCategoriesSuccess = (data: Category) => action(ChatActionTypes.GET_CATEGORIES_SUCCESS, data);
export const getChatCategoriesFailure = () => action(ChatActionTypes.GET_CATEGORIES_FAILURE);
export const getChatCategoriesClear = () => action(ChatActionTypes.GET_CATEGORIES_CLEAR);

export const selectRecommendationContentRequest = (botRecommendationRequest: BotRecommendationRequest) =>
    action(ChatActionTypes.SELECT_RECOMMENDATION_CONTENT_REQUEST, botRecommendationRequest);
export const selectRecommendationContentSuccess = () => action(ChatActionTypes.SELECT_RECOMMENDATION_CONTENT_SUCCESS);
export const selectRecommendationContentFailure = () => action(ChatActionTypes.SELECT_RECOMMENDATION_CONTENT_FAILURE);

export const closeChatModal = () => action(ChatActionTypes.CLOSE_CHAT_MODAL);
export const openChatModal = () => action(ChatActionTypes.OPEN_CHAT_MODAL);

export const sendNewMessageSuccess = (chatbotOutput: ChatbotOutput) => action(ChatActionTypes.SEND_NEW_MESSAGE_SUCCESS, chatbotOutput);

export const setUnreadMessages = () => action(ChatActionTypes.SET_UNREAD_MESSAGES);

export const setBotAction = (data: BotAction) => action(ChatActionTypes.SET_BOT_ACTION, data);
export const dismissBotAction = () => action(ChatActionTypes.DISMISS_BOT_ACTION, action);
